export default {
      id: "card-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#card",
      toString: function () {
        return this.url;
      }
    }